import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "element-ui/lib/theme-chalk/index.css"
import ElementUI from "element-ui"
import "./utils/autoweb"
import "./assets/style/global.css"
// import "./utils/autoweb"

Vue.config.productionTip = false
Vue.use(ElementUI)

const selectedLanguage = store.state.selectedLanguage || "zh"
document.title =
  selectedLanguage === "en" ? "Funlink-Help center" : "Funlink-帮助中心"

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")
